// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Ak-z","tupacHeader":"Bk-z","tupacHeader2":"Ck-z","tupacMenu":"Dk-z","tupacMenu2":"Ek-z","tupacMain":"Fk-z","tupacMain2":"Gk-z"};